import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { PublicOnSiteStore } from 'src/app/shared/services/public-on-site/public-on-site.state';
import { PublicThemeService } from 'src/app/shared/services/public-theme.service';

export const onSiteInitializationResolver: ResolveFn<boolean> = (route) => {
  const _publicOnSiteStore = inject(PublicOnSiteStore);
  const _publicThemeService = inject(PublicThemeService);

  const eventId = route.paramMap.get('id');
  const token = route.queryParamMap.get('token') || undefined;

  _publicOnSiteStore.updateState({ eventId, token });
  if (eventId) {
    _publicOnSiteStore.hydratePrinterSelections(eventId);
  }
  _publicOnSiteStore.getEventDetails({
    onSuccess: ({ coordinatorInfo }) =>
      _publicThemeService.updateTheme(coordinatorInfo.primaryColor)
  });
  return true;
};
